import { createFileRoute } from "@tanstack/react-router";
import AboutPage from "@/site/pages/about";

export const Route = createFileRoute("/about")({
  component: AboutPage,
});
